module.exports = __webpack_public_path__ + "static/logo_en-cf27be7c5b0e3deaee8eb59dfb040744.png";